<template>
  <div class="agentIntroduction">
    <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
      <el-row>
        <el-col :sm="24" :md="16" :lg="16">
          <el-form-item label="名称" prop="name">
            <el-input v-model="addForm.name" placeholder="请输入名称" auto-complete="off" maxlength="30"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="16" :lg="16">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="addForm.companyName" placeholder="请输入公司名称" auto-complete="off"
                      maxlength="255"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="16" :lg="16">
          <el-form-item label="备案号" prop="recordNumber">
            <el-input v-model="addForm.recordNumber" placeholder="请输入备案号" auto-complete="off"
                      maxlength="255"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="状态" prop="enabled">
            <el-radio-group v-model="addForm.enabled">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="机构介绍">
            <div style="background: #FFF" v-if="showUe">
              <UE name="1" :value="ueTtext" ref="myQuillEditorTitle"></UE>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="公司地址">
            <div style="background: #FFF" v-if="showUe">
              <UE name="2" :value="companyAddress" ref="companyAddress"></UE>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <el-button type="primary" style="margin-left:80px" @click="submit" :loading="submitBlock">保存</el-button>
    </div>
  </div>
</template>
<script>
import UE from "../conmom/CKEditorInformation.vue";
import draggable from "vuedraggable";
export default {
  components: { UE, draggable },
  data() {
    return {
      submitBlock: false,
      showUe: false,
      addForm: {
        name: null,
        enabled: 1,
        recordNumber: null,
        remark: null
      },
      formLabelWidth: "80px",
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        companyName: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur"
          }
        ],
        recordNumber: [
          {
            required: true,
            message: "请输入备案号",
            trigger: "blur"
          }
        ],
        enabled: {
          required: true,
          message: "请选择状态",
          trigger: "change"
        },
        remark: {
          required: true,
          message: "请输入机构介绍",
          trigger: "change"
        }
      },
      companyAddress:''
    };
  },
  methods: {
    getAgentInfo() {
      this.api.getAgentInfo().then(result => {
        if (result.success) {
          if (result.data != null) {
            this.addForm = result.data;
            this.ueTtext = this.addForm.remark;
            this.companyAddress = this.addForm.companyAddress;
            this.showUe = true;
            this.editBlock = true;
          } else {
            this.$nextTick(function() {
              this.showUe = true;
            });
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    submit() {
      if (this.submitBlock) {
        return;
      }
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.submitBlock = true;
          if (this.editBlock) {
            this.updateAgentInfo();
            this.updateFooterAdd();
          } else {
            this.addAgentInfo();
            this.addFooterAdd();
          }
        }
      });
    },
    addAgentInfo() {
      if (this.$refs.myQuillEditorTitle.content) {
        this.addForm.remark = this.$refs.myQuillEditorTitle.content;
        this.api.agentInfo.addAgentInfo(this.addForm).then(result => {
          if (result.success) {
            this.submitBlock = false;
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        });
      }else{
        this.submitBlock = false;
        this.$message.error("请输入机构介绍信息")
      }
    },
    updateAgentInfo() {
      if (this.$refs.myQuillEditorTitle.content) {
        this.addForm.remark = this.$refs.myQuillEditorTitle.content;
        this.api.agentInfo.updateAgentInfo(this.addForm).then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.submitBlock = false;
          } else {
            this.$message.error(result.message);
          }
        });
      }else{
        this.submitBlock = false;
        this.$message.error("请输入机构介绍信息")
      }
    },
    addFooterAdd() {
      if (this.$refs.companyAddress.content) {
        this.addForm.companyAddress = this.$refs.companyAddress.content;
        this.api.agentInfo.addAgentInfo(this.addForm).then(result => {
          if (result.success) {
            this.submitBlock = false;
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        });
      }else{
        this.submitBlock = false;
        this.$message.error("请输入公司地址")
      }
    },
    updateFooterAdd() {
      if (this.$refs.companyAddress.content) {
        this.addForm.companyAddress = this.$refs.companyAddress.content;
        this.api.agentInfo.updateAgentInfo(this.addForm).then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.submitBlock = false;
          } else {
            this.$message.error(result.message);
          }
        });
      }else{
        this.submitBlock = false;
        this.$message.error("请输入公司地址")
      }
    },
  },
  mounted() {
    this.getAgentInfo();
  }
};
</script>
<style scoped>
.avatar-uploader-logo .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-logo .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
}
.avatar {
  width: 60px;
  height: 60px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/agentIntroduction.vue